import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import Socials from "../components/about/socials";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/about.css";

const About = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "about");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`About | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="about" />
				<div className="content-wrapper">
					<div className="about-logo-container">
						<div className="about-logo">
							<Logo width={46} />
						</div>
					</div>

					<div className="about-container">
						<div className="about-main">
							<div className="about-right-side">
								<div className="title about-title">
									{INFO.about.title}
								</div>

								<div className="subtitle about-subtitle">
									{INFO.about.description}
								</div>

								<div className="subtitle about-subtitle">
									<span className="skills-heading">SKILLS</span>
									<div>
										<span className="skills-subheading about-subtitle">Programming Languages:</span>  Java, JavaScript, TypeScript,
										HTML, CSS
									</div>
									<div>
										<span className="skills-subheading">Frontend Development:</span> React.js, Tailwind CSS,
										Responsive Web Design, State Management, React
										Router, Axios, State Management (Context API / Redux),
										UI/UX Optimization
									</div>
									<div>
										<span className="skills-subheading">Backend & Databases:</span> Node.js, Express.js, MongoDB,
										Mongoose (ODM), MySQL, RESTful API Integration, JWT
										Authentication, CORS
									</div>
									<div>
										<span className="skills-subheading"> MERN Stack Development:</span>
										(MongoDB, Express.js, React.js, Node.js)
									</div>
									<div>
										<span className="skills-subheading">Automation & AI:</span> AI Agent Development (Crew AI),
										Multi-Agent Orchestration, UiPath Document
										Understanding, Intelligent OCR, ML-based Document
										Processing & Automation.
									</div>
									<div>
										<span className="skills-subheading">Version Control & Collaboration:</span> Git, GitHub, Pull
										Request (PR) Management
									</div>
									<div>
										<span className="skills-subheading">Tools & Platforms:</span> Vite, NPM, Postman, VS Code, ESLint,
										Nodemon, MongoDB Atlas (Cloud DB), React DevTools
									</div>
								</div>
							</div>

							<div className="about-left-side">
								<div className="about-image-container">
									<div className="about-image-wrapper">
										<img
											src="about1.jpg"
											alt="about"
											className="about-image"
										/>
									</div>
								</div>

								<div className="about-socials">
									<Socials />
								</div>
							</div>
						</div>
						<div className="about-socials-mobile">
							<Socials />
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default About;
